import { dew as _transactionDew } from "../../errors/transaction.js";
import { dew as _transactionReceiptDew } from "../../utils/formatters/transactionReceipt.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getTransactionReceipt = void 0;
  const transaction_js_1 = _transactionDew();
  const transactionReceipt_js_1 = _transactionReceiptDew();
  async function getTransactionReceipt(client, {
    hash
  }) {
    const receipt = await client.request({
      method: "eth_getTransactionReceipt",
      params: [hash]
    });
    if (!receipt) throw new transaction_js_1.TransactionReceiptNotFoundError({
      hash
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || transactionReceipt_js_1.formatTransactionReceipt;
    return format(receipt);
  }
  exports.getTransactionReceipt = getTransactionReceipt;
  //# sourceMappingURL=getTransactionReceipt.js.map
  return exports;
}